import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { InitAction, NotificationAction, UserAction } from "../actions";
import * as initApi from "../api/init";
import * as accountTitleApi from "../api/accountTitle";
import { toastr } from "react-redux-toastr";
import { getCookie, setCookie } from "../lib/cookie";
import {
  COMPLETE_INFO_REMINDER,
  CURRENCY,
  FAST_TUTORIAL_LINK,
  PROJECT_USER_ID
} from "../constants/storageKeys";
import { removeProjectRelatedLocalStorage } from "../assets/projectLocalStorage";
import { SetMessage } from "../assets/errorMessages";
import { COMPANIES_LIST } from "../constants/urls";
import { goBack } from "connected-react-router";

export function* watcherInit() {
  yield takeLatest(types.INIT_REQUEST, initWorker);
  yield takeLatest(types.INIT_HELP_STATUS, helpStatus);
  yield takeLatest(
    types.COMPLETE_PROJECT_INFO_CONFIRM_DATA,
    completeProjectInfoConfirmData
  );
  yield takeLatest(
    types.COMPLETE_PROJECT_INFO_CONFIRM_CLOSE,
    completeProjectInfoConfirmClose
  );
  yield takeLatest(
    types.ACCOUNT_TITLE_LEVEL_UPDATE_REQUEST,
    accountTitleLevelUpdate
  );
  yield takeLatest(
    types.USE_IMPREST_SEQUENCE_REQUEST,
    useImprestSequenceUpdate
  );
  yield takeLatest(types.CONNECT_WITH_API_REQUEST, connectWithApi);
  yield takeLatest(types.CONNECT_TO_PARTNER_REQUEST, connectToPartners);
  yield takeLatest(
    types.PROJECT_TRANSACTION_DATE_LIMIT_REQUEST,
    transactionDateLimitStore
  );
}

function fetchInit() {
  return initApi.init();
}

function* initWorker() {
  try {
    const response = yield call(fetchInit);
    const data = response.data;
    if (data.data && data.data.project && data.data.project.is_archived) {
      throw {
        currentProjectHasBeenArchived:
          "شرکت جاری به لیست شرکت‌های آرشیو شده منتقل شده است. لطفا یک شرکت دیگر را انتخاب کنید."
      };
    }
    localStorage.setItem(CURRENCY, data.project.currency.symbol_fa);
    localStorage.setItem(FAST_TUTORIAL_LINK, data.user.step_by_step);
    yield put(
      NotificationAction.setNotificationCount(data.notifications_count)
    );
    yield put(UserAction.getInfoSuccess(data.user));
    yield put(InitAction.getSuccess(data));
  } catch (error) {
    if (error.currentProjectHasBeenArchived) {
      toastr.info(" ", error.currentProjectHasBeenArchived.toString());
      yield setTimeout(() => {
        removeProjectRelatedLocalStorage();
        window.location.replace(COMPANIES_LIST);
        InitAction.getFailure(null);
      }, 1000);
    } else if (
      error.response &&
      (error.response.status === 403 || error.response.status === 404)
    ) {
      if (
        error.response.data &&
        (error.response.data.project_not_found ||
          error.response.data.project_status_expired)
      ) {
        SetMessage(error, true);
      }
      yield setTimeout(() => {
        removeProjectRelatedLocalStorage();
        window.location.replace(COMPANIES_LIST);
        InitAction.getFailure(null);
      }, 1000);
    } else {
      const message = SetMessage(error);
      yield put(InitAction.changeServerInterruptStatus(message));
      yield put(InitAction.getFailure(message));
    }
    // if (error.response && error.response.status === 403) {
    //   yield put(
    //     InitAction.getFailure(
    //       null,
    //       error.response.data && error.response.data.user_not_verified
    //     )
    //   );
    //   if (
    //     error.response.data &&
    //     (error.response.data.project_status_expired ||
    //       error.response.data.user_limit_exceeded)
    //   ) {
    //     localStorage.clear();
    //     sessionStorage.clear();
    //     checkErrorMessagesExist(error) &&
    //       error.response.data.message.forEach(message => {
    //         toastr.error(" ", message.toString());
    //       });
    //     setTimeout(() => window.location.href=COMPANIES_LIST, 0);
    //   } else if (error.response.data && error.response.data.user_not_verified) {
    //     localStorage.clear();
    //     sessionStorage.clear();
    //     deleteCookie("refreshToken");
    //     deleteCookie("accessToken");
    //     window.location.href=REGISTER
    //   }
    //   // else {
    //   //   if (window.location.pathname !== "/verify") {
    //   //     // window.location.replace("/verify");
    //   //   }
    //   // }
    // }
    // if (error.response && error.response.status === 404) {
    //   yield put(InitAction.getFailure(error.response.data));
    //   yield put(
    //     InitAction.getSuccess(
    //       error.response.data.data,
    //       error.response.data.project_not_found
    //     )
    //   );
    // }
    // if (error.m) {
    //   yield put(InitAction.getFailure(null));
    //   localStorage.clear();
    //   sessionStorage.clear();
    //   toastr.success(" ", error.m.toString());
    //   window.location.reload();
    // }
  }
}

function fetchHelpStatus(status) {
  return initApi.helpStatus(status);
}

function* helpStatus(action) {
  try {
    yield call(fetchHelpStatus, action.payLoad);
  } catch (error) {}
}

function* completeProjectInfoConfirmData(action) {
  try {
    if (action.data.changeCookie) {
      const projectUserId = localStorage.getItem(PROJECT_USER_ID);
      if (!getCookie(`${COMPLETE_INFO_REMINDER}-${projectUserId}`)) {
        setCookie(
          `${COMPLETE_INFO_REMINDER}-${projectUserId}`,
          true,
          5 * 24 * 60 * 60 * 1000
        );
      }
    }
  } catch (error) {}
}

function* completeProjectInfoConfirmClose(action) {
  try {
    if (action.changeCookie) {
      const projectUserId = localStorage.getItem(PROJECT_USER_ID);
      if (!getCookie(`${COMPLETE_INFO_REMINDER}-${projectUserId}`)) {
        setCookie(
          `${COMPLETE_INFO_REMINDER}-${projectUserId}`,
          true,
          5 * 24 * 60 * 60 * 1000
        );
      }
    }
  } catch (error) {}
}

function updateAccountTitleLevel(data) {
  return accountTitleApi.updateAccountTitleLevel(data);
}

function* accountTitleLevelUpdate(action) {
  try {
    const response = yield call(updateAccountTitleLevel, action.data);
    const data = response.data;
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(InitAction.accountTitleLevelUpdateSuccess(data.data));
  } catch (error) {
    const message = SetMessage(error, true);
    yield put(InitAction.accountTitleLevelUpdateFailure(message));
  }
}

function updateUseImprestSequence(data) {
  return initApi.updateUseImprestSequence(data);
}

function* useImprestSequenceUpdate(action) {
  try {
    const response = yield call(updateUseImprestSequence, action.data);
    const data = response.data;
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(InitAction.useImprestSequenceUpdateSuccess(data.data));
  } catch (error) {
    const message = SetMessage(error, true);
    yield put(InitAction.useImprestSequenceUpdateFailure(message));
  }
}

function updateConnectWithApi(data) {
  return initApi.updateConnectWithApi(data);
}

function* connectWithApi(action) {
  try {
    const response = yield call(updateConnectWithApi, action.data);
    const data = response.data;
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(InitAction.connectWithApiSuccess(data));
  } catch (error) {
    const message = SetMessage(error, true);
    yield put(InitAction.connectWithApiFailure(message));
  }
}

function updateConnectToPartners(data) {
  return initApi.updateConnectToPartners(data);
}

function* connectToPartners(action) {
  try {
    const response = yield call(updateConnectToPartners, action.data);
    const data = response.data;
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(InitAction.connectToPartnerSuccess(data.data));
  } catch (error) {
    const message = SetMessage(error, true);
    yield put(InitAction.connectToPartnerFailure(message));
  }
}

function updateTransactionDateLimit(data) {
  return initApi.updateTransactionDateLimit(data);
}

function* transactionDateLimitStore(action) {
  try {
    const response = yield call(updateTransactionDateLimit, action.data);
    const data = response.data;
    console.log(data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(InitAction.transactionDateLimitStoreSuccess(data.data));
    yield put(goBack());
  } catch (error) {
    console.log(error);
    const message = SetMessage(error, true);
    yield put(InitAction.transactionDateLimitStoreFailure(message));
  }
}
